// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarChartTeacher_wrapper__1maid","wrapperChart":"BarChartTeacher_wrapperChart__27J0q","yAxies":"BarChartTeacher_yAxies__3TwCf"};